angular.module('security-redirect', [
    'ngCookies',
    'inetsys.modal',
    'route',
    'user',
]);
